<div class="modal">
    <div class="modal-content">
        <h2>{{ 'CVDeepAnalyzer.compareCVJobOffer.moreInfoTitle' | translate }}</h2>
        <div *ngIf="!content_more_information">
            <img src="assets/spinner.gif" alt="Loading" style="width: 40px; height: 40px;"  />
        </div>
        <div *ngIf="content_more_information" class="content-more-information" [innerHTML]="content_more_information">

        </div>
        <div class="actions">
            <button mat-button (click)="closeModal()">
                {{ 'modalGeneral.close' | translate }}
            </button>
        </div>
    </div>
</div>